// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvolvementSkill } from './involvement-skill';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags
import { UtilityService } from '../core.module';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Involvement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get whenLocal() {
        return UtilityService.utcToLocal(this.when, false);
    }
    set whenLocal(value) {
        this.when = UtilityService.localToUtc(value);
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  personId!: number;
  skillId!: number;
  when!: Date;
  person!: Person;
  skill!: InvolvementSkill;
}

